/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerConfig } from '../../config/header.config';

export interface IHeaderMethods extends IPluginMethodMap {
  getHeaderProps(args: any): Promise<any>;
}

export class HeaderService implements IAgentPlugin {
  readonly methods: IHeaderMethods;

  constructor() {
    this.methods = {
      getHeaderProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return { ...(headerConfig || {}) };
  }
}
